var Faq_Categories = {
    init:function(){
        Debug.log("BLOCK CATEGORIES INIT");
        $(".block-categories .btn-categorie").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }

            Faq_Categories.change_faq($(this).attr("data-cat"));
        });
        $('.faq-intro .form-search').on('submit', function (ev) {
            ev.preventDefault();
            words = $('#name').val();
            Faq_Categories.search(words);
        });

    },
    change_faq:function(_slug){
        Debug.log("change_faq : " + _slug);

        $(".block-categories .btn-categorie").each(function(){
            if($(this).attr("data-cat") == _slug){
                $(this).addClass("selected");
            }else{
                $(this).removeClass("selected");
            }
        })

        $(".faq-list-container .block-faq-container").each(function(){
            if($(this).attr("data-cat") == _slug){
                $(this).addClass("selected");
                $(this).find('.item').each(function(){
                    $(this).show();
                    $(this).removeClass('show');
                });
                var _hdest = $(this).find(".block-faq").outerHeight() + 100;
                $(this).css({height:_hdest+"px"});

                var _this = $(this);

                setTimeout(function(){
                    var _scrollDest = _this.offset().top;

                    $('html, body').animate({scrollTop:_scrollDest}, 500);
                }, 40);

                setTimeout(function(){
                    _this.css({height:"auto"})
                }, 500)
            }else{
                $(this).removeClass("selected");
                $(this).css({height:0})
            }
        })
    },
    search: function (words){
        $('.searched').html(words);
        words = words.split(' ');
        $('.faq-list-container .block-faq-container[data-cat="all"]').find('.item').each(function (){
            $(this).removeClass('show');
        });
        words.forEach(function(word){
            $('.faq-list-container .block-faq-container[data-cat="all"]').find('.item').each(function(){
                if($(this).find('.title').text().includes('word') || $(this).find('.texte-container').text().includes(word)){
                    $(this).show();
                    $(this).addClass('show');
                }else{
                    if(!$(this).hasClass('show')){
                        $(this).hide();
                    }
                }
            });
        });
        $(".faq-list-container .block-faq-container").each(function() {
            if ($(this).attr("data-cat") == 'all') {
                $(this).addClass("selected");

                var _hdest = $(this).find(".block-faq").outerHeight() + 100;
                $(this).css({height: _hdest + "px"});

                var _this = $(this);

                setTimeout(function () {
                    var _scrollDest = _this.offset().top;

                    $('html, body').animate({scrollTop: _scrollDest}, 500);
                }, 40);

                setTimeout(function () {
                    _this.css({height: "auto"})
                }, 500)
            } else {
                $(this).removeClass("selected");
                $(this).css({height: 0})
            }
        });

    }

}
$(window).load(function(){
    if($(".block-categories").length){
        Faq_Categories.init();
    }
})